module.exports = __webpack_public_path__ + "img/rightArrows1.910df719.svg";